import { Grid } from "@mui/material";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { MprcInputStyles } from "components/filter/MprcInputStyles";
import { AutoCompleteDataModel } from "components/MprcAutoComplete";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IAdvFilterPickerProps } from "views/general/AdvancedFilter/interfaces";
import { ClassroomAutoComplete } from "views/lms/classroom/components/ClassroomAutoComplete";

////////////////////////////////////////////////////////////////////////////

export const ClassroomPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);
    const multiSelect = filter.canRepeat ?? false;

    var trainingId = filter.pickerParams.trainingId as string;
    var onlyActive = filter.pickerParams.onlyActive as boolean;

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            }));
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////


    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <ClassroomAutoComplete
                    autoFocus
                    placeholder={t(`AdvFilter.Picker.Classroom.Placeholder${multiSelect ? "_multi" : ""}`)}
                    trainingId={trainingId}
                    multiSelect={multiSelect}
                    selectedItems={selected}
                    onlyActive={onlyActive}
                    onChange={(items) => setSelected(items)}
                    onError={MprcRequestSnackbarErrorReport}
                    onApply={handleApply}
                    onCancel={onCancel}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
